// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Card, Personalcard, UserSquare } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  account: UserSquare,
  user: Personalcard,
  payment: Card
};

// ==============================|| MENU ITEMS - DEVELOPMENT ||============================== //

const development: NavItemType = {
  id: 'account-group',
  title: <FormattedMessage id="common.menu.account.group" />,
  type: 'group',
  children: [
    {
      id: 'user',
      title: <FormattedMessage id="common.menu.account.myAccount" />,
      type: 'item',
      url: '/account/profile',
      icon: icons.account
    }
    // {
    //   id: 'account',
    //   title: 'Cuenta',
    //   type: 'collapse',
    //   icon: icons.account,
    //   children: [
    //     {
    //       id: 'user',
    //       title: 'Mi perfil',
    //       type: 'item',
    //       url: '/account',
    //       icon: icons.user
    //     },
    //     {
    //       id: 'payment',
    //       title: 'Método de pago',
    //       type: 'item',
    //       url: '/account/payment',
    //       icon: icons.payment
    //     }
    //   ]
    // }
  ]
};

export default development;
